import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

type TabName = 'Home' | 'Menu' | 'Cart' | 'Orders' | 'Stores';

const WebNavigator: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabName>('Home');

  const getTabIcon = (tabName: TabName): string => {
    switch (tabName) {
      case 'Home':
        return '🏠';
      case 'Menu':
        return '📋';
      case 'Cart':
        return '🛒';
      case 'Orders':
        return '📦';
      case 'Stores':
        return '🏪';
      default:
        return '📱';
    }
  };

  const renderScreen = () => {
    return (
      <View style={styles.screenContainer}>
        <Text style={styles.screenTitle}>{activeTab} Screen</Text>
        <Text style={styles.screenContent}>
          Welcome to {activeTab}! This is a simple web-compatible navigation.
        </Text>
      </View>
    );
  };

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {renderScreen()}
      </View>
      <View style={styles.tabBar}>
        {(['Home', 'Menu', 'Cart', 'Orders', 'Stores'] as TabName[]).map((tab) => (
          <TouchableOpacity
            key={tab}
            style={[
              styles.tab,
              activeTab === tab && styles.activeTab
            ]}
            onPress={() => setActiveTab(tab)}
          >
            <Text style={styles.tabIcon}>{getTabIcon(tab)}</Text>
            <Text style={[
              styles.tabText,
              activeTab === tab && styles.activeTabText
            ]}>
              {tab}
            </Text>
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );
};

export default WebNavigator;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  content: {
    flex: 1,
  },
  screenContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  screenTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 16,
    color: '#333',
  },
  screenContent: {
    fontSize: 16,
    textAlign: 'center',
    color: '#666',
  },
  tabBar: {
    flexDirection: 'row',
    backgroundColor: '#f8f9fa',
    borderTopWidth: 1,
    borderTopColor: '#e9ecef',
    paddingVertical: 8,
  },
  tab: {
    flex: 1,
    alignItems: 'center',
    paddingVertical: 8,
  },
  activeTab: {
    backgroundColor: '#e3f2fd',
    borderRadius: 8,
    marginHorizontal: 4,
  },
  tabIcon: {
    fontSize: 20,
    marginBottom: 4,
  },
  tabText: {
    fontSize: 12,
    color: '#666',
  },
  activeTabText: {
    color: '#1976d2',
    fontWeight: 'bold',
  },
});